import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { BillingResponse } from '@billing/entities/billing.payload';
import {
  fetchUserBillingsSuccessAction,
  setBillingSuccessAction,
  deleteBillingSuccessAction,
  createBillingSuccessAction,
  resetBillingModuleAction
} from '@billing/store/actions/billing.actions';
import {
  fetchAirValidationAction,
  fetchHotelValidationAction,
  fetchPackageValidationAction,
  fetchAutoValidationAction,
  fetchAirValidationBySectorAction
} from '@booking/store/actions/booking.actions';

export interface BillingResponseState extends EntityState<BillingResponse> { }

function getId(billing: BillingResponse): string {
  return billing._id;
}

export const billingAdapter: EntityAdapter<BillingResponse> = createEntityAdapter<BillingResponse>({
  selectId: getId
});

export const initialState = billingAdapter.getInitialState({});

export const billingInfoReducer = createReducer(
  initialState,
  on(fetchUserBillingsSuccessAction, (state, { response }) => billingAdapter.setAll(response, state)),
  on(createBillingSuccessAction, (state, { response }) => billingAdapter.addOne(response, state)),
  on(setBillingSuccessAction, (state, { response }) => {
    const billingResponse: BillingResponse = {
      user_id: response.userId,
      _id: response.billingId,
      billing_info: response.billingInfo.billing_info
    };
    return billingAdapter.updateOne(
      {
        id: response.billingId,
        changes: billingResponse
      },
      state
    );
  }),
  on(deleteBillingSuccessAction, (state, { response }) => billingAdapter.removeOne(response.billingId, state)),
  on(fetchAirValidationAction, () => initialState),
  on(fetchAirValidationBySectorAction, () => initialState),
  on(fetchHotelValidationAction, () => initialState),
  on(fetchPackageValidationAction, () => initialState),
  on(fetchAutoValidationAction, () => initialState),
  on(resetBillingModuleAction, () => initialState)
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = billingAdapter.getSelectors();
